module.exports = __webpack_public_path__ + "static/media/villaraigosa.38b5714f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/june-5/races/images/villaraigosa.png
// module id = 642
// module chunks = 40 46 55